import { onDocumentLoaded } from '@theme/utilities';

const capitalizeElements = (selector) => {
  try {
    const elements = document.querySelectorAll(selector);

    if (elements.length === 0) {
      console.warn(`No se encontraron elementos con el selector: ${selector}`);
      return;
    }

    elements.forEach(element => {
      const text = element.textContent;
      const capitalizedText = text
        .toLowerCase()
        .split(' ')
        .map(word => {
          // Capitalize "pg" specifically to "PG"
          if (word === 'pg') {
            return 'PG';
          }
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
      
      element.textContent = capitalizedText;
    });
  } catch (error) {
    console.error(`Error al capitalizar los elementos con el selector "${selector}":`, error);
  }
};

const openFirstMenuElements = () => {
  const elementChildLists = document.querySelectorAll('.menu-drawer__menu--childlist');
  elementChildLists.forEach((element) => {
    const firstElement = element.querySelector('li:first-child');
    if (firstElement) {
      const firstDetail = firstElement.querySelector('details');
      if (firstDetail) {
        firstDetail.setAttribute('open', '');
      }
    }
  });
};

onDocumentLoaded(() => {
  capitalizeElements('.product-details h1');
  capitalizeElements('.h3 p');
  capitalizeElements('.card-gallery .contents p');
  //capitalizeElements('.product-card a.contents p');
});

window.addEventListener('load', () => {
  setTimeout(() => {
    openFirstMenuElements();
  }, 500);
});
